import { of } from "rxjs";
import { catchError, filter, map, mergeMap } from "rxjs/operators";

import { Effect } from "../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../redux/types/effect-actions-observable.type";
import { isActionType } from "../../../redux/action.functions";

import * as actions from "./product-history.actions";
import { ProductHistoryActions } from "./product-history.actions";
import * as services from "../services/product-history.services";
import { IError } from "../../../redux/actions/errorHandlingAction";

const fetchHistory: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(ProductHistoryActions.ProductHistoryFetch)),
    map((action) => action.payload),
    mergeMap(({ resourceType, resourceId, productId }) =>
      services.fetchHistory(resourceType, resourceId).pipe(
        map((results) => actions.fetchSuccess(results)),
        catchError((error) => of(actions.fetchFailure(setTimeoutError(error))))
      )
    )
  );

const nextHistory: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(ProductHistoryActions.ProductHistoryNext)),
    map((action) => action.payload),
    mergeMap((endpoint) =>
      services.nextHistory(endpoint).pipe(
        map((results) => actions.nextSuccess(results)),
        catchError((error) => of(actions.nextFailure(setTimeoutError(error))))
      )
    )
  );

const setTimeoutError = (error: IError) => {
  if ([408, 460, 504, 598, 524].includes(error.status)) {
    return {
      ...error,
      errorMessage:
        "This request timed out, but it will continue processing in the background. Please load it again in a moment to check the progress.",
    };
  }

  return error;
};

export const ProductHistoryEffects = [fetchHistory, nextHistory];
